import { Record } from 'immutable';
import * as types from './actionTypes';

const initialState = Record({
  accessoryConfig: null,
  insigniaEnabledMakes: null,
  fetching: false,
  error: null,
});

export default (state = initialState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.ACCESSORY_CONFIG_REQUEST:
      return state
        .set('fetching', true)
        .set('error', null)
        .set('accessoryConfig', null);
    case types.ACCESSORY_UPDATE_REQUEST:
    case types.ACCESSORY_CONFIG_UPDATE_REQUEST:
      return state.set('fetching', true).set('error', null);
    case types.ACCESSORY_CONFIG_SUCCESS:
    case types.ACCESSORY_CONFIG_UPDATE_SUCCESS:
      return state
        .set('fetching', false)
        .set('error', null)
        .set('accessoryConfig', payload);
    case types.ACCESSORY_UPDATE_SUCCESS:
      return state.set('fetching', false).set('error', null);
    case types.ACCESSORY_CONFIG_FAILURE:
    case types.ACCESSORY_UPDATE_FAILURE:
    case types.ACCESSORY_CONFIG_UPDATE_FAILURE:
      return state.set('fetching', false).set('error', payload);
    case types.INSIGNIA_ENABLED_SUCCESS:
      return state.set('insigniaEnabledMakes', payload);
    default:
      return state;
  }
};
